import { GeoAPITypeEnum } from '@shared/models/geo-api-type.model';

export enum MapLayers {
  Cameras                   = 'Cameras',
  Situations                = 'Situations',
  Traffic                   = 'Traffic',
  TrafficSpeedRange         = 'TrafficSpeedRange',
  TrafficConcordance        = 'TrafficConcordance',
  PmvEditar                 = 'PmvEditar',
  PmvConsulta               = 'PmvConsulta',
  Pmv                       = 'Pmv',
  Blank                     = 'Blank',
  close_session             = 'close_session',
  Co2                       = 'Co2',
  Aforo                     = 'Aforo',
  BicyclePath               = 'BicyclePath',
  ParkingLot                = 'ParkingLot',
  TrafficLight              = 'TrafficLight',
  Agents                    = 'Agents',
  AgentsHistorical          = 'AgentsHistorical',
  TrafficManagmentPlans     = 'TrafficManagmentPlans',
  StopBus                   = 'StopBus',
  RouteBus                  = 'RouteBus',
  BusZone                   = 'BusZone',
  Zones                     = 'Zones',
  RoadRun                   = 'RoadRun',
  Accident                  = 'Accident',
  change_pass               = 'change_pass',
  RuntDatex                 = 'RuntDatex',
  MatrixODsensor            = 'MatrixODModel',
  MatrixODcamera            = 'MatrixODCameraModel',
  Skateboards               = 'Skateboards',
  ParkingZone               = 'ParkingZone',
  ParkingZoneLoading        = 'ParkingZoneLoading',
  ParkingSpot               = 'ParkingSpot',
  PanicButton               = 'PanicButton',
  ResourcesAirQualityPoints = "ResourcesAirQualityPoints",
  CapactyPoints             = "CapactyPoints",
  ParkingSquarePMR          ="ParkingSquarePMR",
  CamerasPoints           = 'CamerasPoints',
  Luminary                = 'Luminary',
  Garbage                 = 'Garbage',
}

export const LayersDataMap: { [key: string]: GeoAPITypeEnum[] } = {
  [MapLayers.Situations]                : [GeoAPITypeEnum.Situation],
  [MapLayers.Traffic]                   : [GeoAPITypeEnum.Traffic],
  [MapLayers.TrafficConcordance]        : [GeoAPITypeEnum.TrafficConcordance],
  [MapLayers.TrafficSpeedRange]         : [GeoAPITypeEnum.TrafficSpeedRange],
  [MapLayers.Cameras]                   : [GeoAPITypeEnum.Camera],
  [MapLayers.Blank]                     : [GeoAPITypeEnum.Blank],
  [MapLayers.Co2]                       : [GeoAPITypeEnum.Co2],
  [MapLayers.Aforo]                     : [GeoAPITypeEnum.Aforo],
  [MapLayers.BicyclePath]               : [GeoAPITypeEnum.BicyclePath],
  [MapLayers.ParkingLot]                : [GeoAPITypeEnum.ParkingLot],
  [MapLayers.TrafficLight]              : [GeoAPITypeEnum.TrafficLight],
  [MapLayers.Agents]                    : [GeoAPITypeEnum.Agents],
  [MapLayers.AgentsHistorical]          : [GeoAPITypeEnum.AgentsHistorical],
  [MapLayers.TrafficManagmentPlans]     : [GeoAPITypeEnum.TrafficManagmentPlans],
  [MapLayers.BusZone]                   : [GeoAPITypeEnum.RouteBus, GeoAPITypeEnum.StopBus],
  [MapLayers.Zones]                     : [GeoAPITypeEnum.Zones],
  [MapLayers.RoadRun]                   : [GeoAPITypeEnum.RoadRun],
  [MapLayers.Accident]                  : [GeoAPITypeEnum.Accident],
  [MapLayers.Pmv]                       : [GeoAPITypeEnum.Pmv],
  [MapLayers.PmvConsulta]               : [GeoAPITypeEnum.PmvConsulta],
  [MapLayers.PmvEditar]                 : [GeoAPITypeEnum.PmvEditar],
  [MapLayers.RuntDatex]                 : [GeoAPITypeEnum.RuntDatex],
  [MapLayers.MatrixODsensor]            : [GeoAPITypeEnum.MatrixODsensor],
  [MapLayers.MatrixODcamera]            : [GeoAPITypeEnum.MatrixODcamera],
  [MapLayers.Skateboards]               : [GeoAPITypeEnum.Skateboards],
  [MapLayers.ParkingZoneLoading]        : [GeoAPITypeEnum.ParkingLoadingZone, GeoAPITypeEnum.ParkingSpotLUZone],
  [MapLayers.ParkingZone]               : [GeoAPITypeEnum.ParkingUnderground, GeoAPITypeEnum.ParkingSpotBGZones, GeoAPITypeEnum.ParkingLine,],
  [MapLayers.PanicButton]               : [GeoAPITypeEnum.PanicButton],
  [MapLayers.ParkingSquarePMR]          : [ GeoAPITypeEnum.ParkingSquareZones ],
  [MapLayers.ResourcesAirQualityPoints] : [GeoAPITypeEnum.ResourcesAirQualityPoints],
  [MapLayers.CapactyPoints]             : [GeoAPITypeEnum.Pmv],
  [MapLayers.CamerasPoints]             : [GeoAPITypeEnum.CameraPoints],
  [MapLayers.Luminary]                  : [GeoAPITypeEnum.Luminary],
  [MapLayers.Garbage]                   : [GeoAPITypeEnum.Garbage],
};
